import { preloadIntentBasedOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadIntentBasedOnboardingState.ts';
import { preloadGetLicensedProductsQuery } from '@confluence/onboarding-helpers/entry-points/preloadGetLicensedProductsQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';

export const INTENT_BASED_ONBOARDING_QUERY = 'IntentBasedOnboardingQuery';

export const preloadIntentBasedOnboarding = () => {
	return waitForAllReturnWhenError([
		preloadIntentBasedOnboardingState(),
		preloadGetLicensedProductsQuery(),
	]);
};
